import React from 'react';
import styled from 'styled-components';
import logoBlack from '../assets/Proteus_Black-01.svg';
import { siteConfig } from '../siteConfig';
import { trackEvent } from '../analytics';

const LOGO_HEIGHT = 26;
const LOGO_WIDTH = Math.round((LOGO_HEIGHT * 1000) / 150);

const Container = styled.footer`
  padding: clamp(48px, 7vw, 80px) ${({ theme }) => theme.container.gutter} 40px;
`;

const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 36px;
  max-width: ${({ theme }) => theme.container.maxWidth};
  margin: 0 auto;
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 34ch;
`;

const Blurb = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.95rem;
  line-height: 1.55;
`;

const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: clamp(32px, 5vw, 80px);
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ColumnTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.muted};
`;

const FooterLink = styled.a`
  color: ${({ theme }) => theme.colors.ink};
  font-size: 0.98rem;

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }
`;

const Muted = styled.span`
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.98rem;
`;

const Legal = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  max-width: ${({ theme }) => theme.container.maxWidth};
  margin: 48px auto 0;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.line};
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.76rem;
  color: ${({ theme }) => theme.colors.muted};
`;

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <Container>
      <Inner>
        <Brand>
          <a href="/#top">
            <img
              src={logoBlack}
              alt="Proteus Technologies"
              width={LOGO_WIDTH}
              height={LOGO_HEIGHT}
              loading="lazy"
            />
          </a>
          <Blurb>
            Technology consultancy building robust, scalable solutions across Shipbroking, Legal,
            Media, and startup environments.
          </Blurb>
        </Brand>

        <Columns>
          <Column>
            <ColumnTitle>Site</ColumnTitle>
            <FooterLink href="/#services">Services</FooterLink>
            <FooterLink href="/#industries">Industries</FooterLink>
            <FooterLink href="/#about">About</FooterLink>
            <FooterLink href="/#contact">Contact</FooterLink>
          </Column>
          <Column>
            <ColumnTitle>Contact</ColumnTitle>
            <FooterLink
              href={`mailto:${siteConfig.email}`}
              onClick={() => trackEvent('contact_email_click', { location: 'footer' })}
            >
              {siteConfig.email}
            </FooterLink>
            <Muted>{siteConfig.location}</Muted>
          </Column>
        </Columns>
      </Inner>

      <Legal>
        <span>
          &copy; {year} {siteConfig.companyName}. All rights reserved.
        </span>
        <span>Company No. {siteConfig.companyNumber} (England &amp; Wales)</span>
      </Legal>
    </Container>
  );
};

export default Footer;
